import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/MemberAuthContext';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Přihlášení selhalo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ paddingTop: 60 }}>
      <div className="card">
        <div className="text-center mb-16">
          <img src="/logo.svg" width="56" height="56" alt="TEČČKa" style={{ borderRadius: 12 }} />
          <h1 style={{ marginTop: 10 }}>TEČČKa</h1>
          <p className="text-muted">Technická evidence ČČKa – přihlášení</p>
        </div>
        <form onSubmit={submit}>
          <div className="form-group">
            <label>E-mail</label>
            <input type="email" className="form-input" value={email} autoComplete="username"
              onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Heslo</label>
            <input type="password" className="form-input" value={password} autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <div className="alert alert-warning mb-16">{error}</div>}
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? '...' : 'Přihlásit se'}
          </button>
        </form>
        <p className="text-center text-muted mt-16" style={{ fontSize: '0.9rem' }}>
          Nemáte účet? <Link to="/register">Zaregistrujte se</Link>
        </p>
      </div>
    </div>
  );
}
